<template>
  <div>
    <div class="card-row row" @click="elDraweropen">
       <!-- <div class="card-row-col card-col wp10"
       v-for="(column,index) in sectionHeader"
       :class="column.class"
       :key="index">
          DEV-123
          <small>
            27 Oct 2020
          </small>
        </div> -->
      <div class="card-row-col card-col text-left"
        v-for="(column, index) in sectionHeader"
        :class="column.class"
        :key="index">
        <span v-if="getWalletDetails[column.label]">
          <span v-if="column.label === 'status'" class="status status-icon" :class="getStatusClass()">
            {{getWalletDetails[column.label]}}
            <span class="badge" v-if="isPTLOrder">
              <svgicon name="ptl" width="12" height="12" />
            </span>
          </span>
          <span v-else-if="column.label === 'amount'" :class=" isReasonDebitAdjustment && 'text-red'">
             <div v-if="isApprovalRequired">
            <small>{{ $t('WALLET_SYSTEM_CHARGE') }}: {{getWalletDetails[column.label].system_amount}}</small>
            <small>{{ $t('WALLET_SHIPPER_CHARGE') }}: {{getWalletDetails[column.label].shipper_amount}}</small>
            <small>{{ $t('WALLET_TRANSPORTER_CHARGE') }}: {{getWalletDetails[column.label].transporter_amount}}</small>
          </div>
          <p v-else-if="column.label === 'reference_number'">
            {{ getWalletDetails[column.label] }}
          </p>
          <div v-else>
              {{getWalletDetails[column.label].shipper_amount}}
          </div>
          </span>
          <span v-else-if="column.tooltip">
            <Tooltip class="item" effect="dark" :placement="getWalletDetails[`${column.label}_small`] ? 'top' : 'bottom'"
              v-if="getWalletDetails[column.label].tooltipText">
              <div slot="content" class="tooltipcontent">
                {{getWalletDetails[column.label].tooltipText}}
              </div>
              <button><span>{{getWalletDetails[column.label].value}}</span></button>
            </Tooltip>
            <span v-else>{{getWalletDetails[column.label].value}}</span>
            <small v-if="getWalletDetails[`${column.label}_small`]">
              <Tooltip class="item" effect="dark" placement="bottom"
                v-if="getWalletDetails[`${column.label}_small`].tooltipText">
                <div slot="content" class="tooltipcontent">
                  {{getWalletDetails[column.label].tooltipText}}
                </div>
                <button><span>{{getWalletDetails[column.label].value}}</span></button>
              </Tooltip>
              <span v-else>{{getWalletDetails[`${column.label}_small`].value}}</span>
            </small>
          </span>
          <Ellipsis v-else-if="column.truncateOn"
            :text="getWalletDetails[column.label]"
            :length="column.truncateOn" />
          <span v-else-if="getWalletDetails[`${column.label}_small`]">
            {{getWalletDetails[column.label]}}
            <small>{{getWalletDetails[`${column.label}_small`]}}</small>
          </span>
          <span v-else>{{getWalletDetails[column.label]}}</span>
        </span>
        <span v-else> - </span>
      </div>
      <div class="card-row-col card-col detail-width ml-auto">
        <div v-if="isPTLOrder && isReasonTransitDelay && !isApprovalRequired"
        @click="getConsigneeDetails" class="cursor d-inline-block">
          <svgicon name="details" width="12" height="12" :original="true" />
          <span class="card-actionlabel">{{ $t('DETAILS_SLIDER') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRoute, getRouteNames } from '@common/lib/payments';
import { mapGetters } from 'vuex';
import { WalletStatusList, deliveryTypes, WalletReason, WalletReasonList, movementMapLower } from 'pando-constants';
import moment from 'moment';
import { invert } from 'lodash';

export default {
  props: {
    wallet: {
      type: Object,
      default: () => {},
    },
    sectionHeader: {
      type: Array,
      default: () => [],
    },
    walletConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      WalletStatusList,
      deliveryTypes,
      WalletReason,
      WalletReasonList,
      activeTab: 'REMARKS',
    };
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      currentClientConfig: 'app/currentClientConfig',
    }),
    getWalletDetails() {
      const route = getRoute(this.wallet, this.depots);
      const routeName = getRouteNames(this.wallet, this.depots);
      if (!route.source && this.wallet.depot_data) {
        route.source = this.wallet.depot_data.display_reference_name || this.wallet.depot_data.city;
      }
      if (!routeName.source && this.wallet.depot_data) {
        routeName.source = this.wallet.depot_data.name;
      }
      const amount = {
        amount: this.wallet.shipper_amount,
      };
      if (this.wallet.system_amount || this.wallet.system_amount === 0) {
        amount.system_amount = this.wallet.system_amount;
        amount.shipper_amount = this.wallet.shipper_amount;
        amount.transporter_amount = this.wallet.transporter_amount;
        delete amount.amount;
      }
      const walletDetails = {
        indent_id_small: moment(this.wallet.date).format('DD MMM YYYY'),
        indent_id: this.wallet.indent_id,
        status: this.getStatus(this.wallet.status) && this.getStatus(this.wallet.status).display,
        amount,
        shipment_number: this.wallet.shipment_number,
        reason: this.WalletReasonList.find(reason => reason.id === this.wallet.reason).name,
        client_name: this.wallet.client_name,
        consignee_data: this.wallet.consignee_data,
        route: { value: routeName.source.concat(' - ', routeName.destination),
          tooltipText: routeName.multidropCities },
        route_small: { value: route.source.concat(' - ', route.destination),
          tooltipText: route.multidropCities },
        reference_number: this.wallet.reference_number,
      };
      return walletDetails;
    },
    isPTLOrder() {
      return this.wallet.delivery_type === this.deliveryTypes.PTL;
    },
    isFTLOrder() {
      return this.wallet.delivery_type === this.deliveryTypes.FTL;
    },
    isReasonTransitDelay() {
      return this.wallet.reason === this.WalletReason.TRANSIT_DELAY;
    },
    isReasonDebitAdjustment() {
      return this.wallet.reason === this.WalletReason.DEBIT_ADJUSTMENT;
    },
    isApprovalRequired() {
      const currentWalletConfig = this.walletConfig
      && this.walletConfig[movementMapLower[this.wallet.movement]];
      return (currentWalletConfig && currentWalletConfig.is_approval_required);
    },
  },
  methods: {
    elDraweropen() {
      const invertedWallet = invert(WalletReason);
      const reason = this.wallet.reason;
      const movement = this.wallet.movement;
      const movementLevelConfig = this.currentClientConfig.wallet && this.currentClientConfig.wallet[movementMapLower[movement]];
      const reasonLevelConfig = movementLevelConfig && movementLevelConfig.reason_level_config &&
        movementLevelConfig.reason_level_config[invertedWallet[reason].toLowerCase()];
      let allowSlider = this.wallet.consignee_data;
      allowSlider = (allowSlider && (this.wallet.consignee_data[0].materials
        || this.wallet.consignee_data[0].shipper_amount))
        || this.isReasonTransitDelay;
      allowSlider = allowSlider && this.isApprovalRequired &&
        (reasonLevelConfig && reasonLevelConfig.can_view_slider);
      if (allowSlider || this.$hasFeature('wallet_custom_fields')) {
        this.activeTab = 'DETAILS';
        this.$emit('elDraweropen', this.wallet.id, this.activeTab);
      }
    },
    getConsigneeDetails() {
      if (this.isPTLOrder && this.isReasonTransitDelay && !this.isApprovalRequired) {
        this.activeTab = 'DETAILS';
      }
      this.$emit('getConsigneeDetails', this.wallet.id, this.activeTab);
    },
    getStatus(id) {
      return this.WalletStatusList.find(i => i.id === id);
    },
    getStatusClass() {
      const type = this.getStatus(this.wallet.status).color.toLowerCase();
      return `status-${type}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-width { width: 10%; }
.text-right { text-align: right !important; display: flex; justify-content: flex-end; }
</style>
